import React from "react";
import { useSelector } from "react-redux";
import {
  selectIsOwner,
  selectIsCompanyAdmin,
  selectCurrentCompany,
  selectInviteCode,
} from "../../store/slices/authSlice";
import { useGetCompanyPositionsQuery } from "../../services/api";
import InviteCodeSection from "./components/InviteCodeSection";
import EmailInviteSection from "./components/EmailInviteSection";
import PositionsSection from "./components/PositionsSection";
import TeamMembersSection from "./components/TeamMembersSection";
import "./Team.css";

export default function Team() {
  const company = useSelector(selectCurrentCompany);
  const isOwner = useSelector(selectIsOwner);
  const isCompanyAdmin = useSelector(selectIsCompanyAdmin);
  const inviteCode = useSelector(selectInviteCode);

  const companyId = company?._id || company?.id;

  // Fetch positions
  const {
    data: positions = [],
    isLoading: positionsLoading,
    refetch: refetchPositions,
  } = useGetCompanyPositionsQuery(companyId, { skip: !companyId });

  // Check if user can manage team (owner or company admin)
  const canManage = isOwner || isCompanyAdmin;

  // If no company, show message
  if (!company) {
    return (
      <div className="team-page">
        <h1 className="username">Team</h1>
        <div className="team-no-company">
          <p>You are not part of a company yet.</p>
        </div>
      </div>
    );
  }

  // If not owner/admin, show limited view
  if (!canManage) {
    return (
      <div className="team-page">
        <h1 className="username">Team</h1>
        <div className="team-no-access">
          <p>Only company owners and admins can manage the team.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="team-page">
      <h1 className="username">Team Management</h1>

      {/* Invite Code Section */}
      <InviteCodeSection
        inviteCode={inviteCode}
        companyName={company?.name}
      />

      {/* Email Invitations Section */}
      <EmailInviteSection companyId={companyId} />

      {/* Positions Section */}
      <PositionsSection
        companyId={companyId}
        positions={positions}
        isLoading={positionsLoading}
        refetch={refetchPositions}
      />

      {/* Team Members Section */}
      <TeamMembersSection
        companyId={companyId}
        positions={positions}
      />
    </div>
  );
}
